import { storyblokInit, type SbInitResult } from '@storyblok/js';
import RichTextSchema from './RichTextSchema';
export let storyblokClient: SbInitResult | null = null;

export default function StoryblokClient(): any {
  if (storyblokClient) return storyblokClient;

  storyblokClient = storyblokInit({
    accessToken: '',
    apiOptions: {
      cache: {
        type: 'memory',
        clear: 'auto'
      }
    },
    richText: {
      schema: RichTextSchema
    }
  });

  return storyblokClient;
}
